import React from "react";
import styles from "./ContentNotWide.module.css";

export const ContentNotWide: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className={styles.container}>{children}</div>;
